// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GerY6","placeholdersHeader":"styles_placeholdersHeader__39zfe","editorStyle":"styles_editorStyle__1xxI8","placeholdersBox":"styles_placeholdersBox__1SgHP"};